var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 97,
    viewBox: "0 0 91 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5518_240)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 97,
    rx: 33,
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8035 37.0971C64.5147 37.8144 64.8756 38.7844 64.7932 39.7582L62.4856 67.4047C62.1796 71.0858 58.8417 73.9697 54.8866 73.9697H36.1389C32.1845 73.9697 28.8466 71.0858 28.5393 67.4047L26.2316 39.7582C26.1506 38.7844 26.5114 37.8144 27.2214 37.0971C27.932 36.3798 28.9394 35.9683 29.986 35.9683H61.0395C62.0855 35.9683 63.0935 36.3798 63.8035 37.0971ZM63.4191 28.9412H55.8006L55.6776 27.7343C55.4606 25.6055 53.57 24 51.2806 24H39.8168C37.5268 24 35.6369 25.6055 35.4198 27.7343L35.2968 28.9412H27.6777C26.1989 28.9412 25 30.0608 25 31.4417C25 32.8226 26.1989 33.9422 27.6777 33.9422H63.4191C64.8978 33.9422 66.0968 32.8226 66.0968 31.4417C66.0968 30.0608 64.8978 28.9412 63.4191 28.9412Z",
    fill: "#5E5E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5518_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 97,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ab2cda8139fc22ba5ff0117bc9f46a41.svg";
export { ForwardRef as ReactComponent };